/**
 * The one sun every cast shadow in the world shares: how far a shadow moves along the ground for each
 * pixel of height (x across, y down). People's silhouettes (lpc_composite_sprite) and buildings
 * (building_shadow) both cast with it, so a wall as tall as a person casts a shadow as long as theirs.
 * The default leans to the lower left, like the shading baked into the tree and bush art.
 *
 * Tune live with window.spriteShadowDirX / window.spriteShadowDirY; buildings re-bake on the change.
 */
export const SUN = { x: -0.23, y: 0.13 }

export const sunDirection = (): { x: number; y: number } => {
    const w = typeof window === "undefined" ? undefined : (window as any)
    return {
        x: typeof w?.spriteShadowDirX === "number" ? w.spriteShadowDirX : SUN.x,
        y: typeof w?.spriteShadowDirY === "number" ? w.spriteShadowDirY : SUN.y,
    }
}
